<template>
  <div>
    <b-card body-class="p-0">
      <b-table-simple
        class="manual-time table"
        responsive
      >
        <thead>
          <tr>
            <th class="text-capitalize">
              {{ $t("Start Time") }}
            </th>
            <th class="text-capitalize">
              {{ $t("End Time") }}
            </th>
            <th class="text-capitalize">
              {{ $t("Duration") }}
            </th>
            <th class="text-capitalize w-25">
              {{ $t("Remarks") }}
            </th>
            <th class="text-capitalize">
              {{ $t("Action") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Requested Times -->
          <tr
            v-for="time in requestedTime"
            :key="time.id"
            class="bg-light-warning"
          >
            <td>  {{ FORMAT_DATE(time.startedAt, 'h:mm:ss A') }}</td>
            <td> {{ FORMAT_DATE(time.endedAt, 'h:mm:ss A') }}</td>
            <td>
              <b-badge
                variant="primary"
                class="w-75"
              >
                {{ CONVERT_HM(GET_TIME_DIFFERENCE(time.startedAt, time.endedAt)) }}
              </b-badge>
            </td>
            <td class="text-truncate--3">
              <span v-b-tooltip.hover.left="time.remarks">
                {{ time.remarks }}
              </span>
            </td>
            <td>
              <b-badge variant="warning">
                {{ $t('Pending Approval') }}
              </b-badge>
            </td>
          </tr>
          <!-- Available Slots -->
          <tr
            v-for="(slots,index) of availableSlot"
            :key="index"
            :class="[ getBgColor(slots) ]"
            :set="slot = {
              start: slots.start,
              end: slots.end,
            }"
          >
            <td>  {{ FORMAT_DATE(slot.start, 'h:mm:ss A') }}</td>
            <td> {{ FORMAT_DATE(slot.end, 'h:mm:ss A') }}</td>
            <td>
              {{ CONVERT_HM(GET_TIME_DIFFERENCE(slot.start, slot.end)) }}
            </td>
            <td>
              {{ slots.working ? $t('Working') : $t('Not Working') }}
            </td>

            <td>
              <b-button
                v-if="slots.manual && canApproveManualTime"
                variant="danger"
                class="btn-icon"
                @click="manualTimeToDelete = slots.manual"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-if="!slots.working"
                v-b-tooltip.top="IS_MOBILE() ? '' : $t('Add Manual Time')"
                variant="outline-primary"
                class="btn-icon"
                @click="$emit('updateTime', slots)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </td>
          </tr>
        </tbody>
      </b-table-simple>
      <confirm-delete
        :visible="!!manualTimeToDelete"
        :delete-params="{
          title: $t('Delete Manual Time?'),
          body: $t('Are you sure you want to delete?')
        }"
        :processing="isProcessing"
        @close="manualTimeToDelete = null"
        @onConfirm="destroyManualTime"
      />
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BButton,
  BTableSimple,
  BBadge,
  VBTooltip,
} from 'bootstrap-vue'
import workPatternHelper from '@/utils/workPatternHelper'
import ConfirmDelete from '@/views/common/components/ConfirmModal.vue'
import useApollo from '@/plugins/graphql/useApollo'

export default {
  components: {
    BCard,
    BButton,
    BBadge,
    BTableSimple,
    ConfirmDelete,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    selectedDateRange: {
      type: Object,
      default: () => {},
    },
    timezone: {
      type: String,
      required: true,
    },
    canApproveManualTime: {
      type: Boolean,
      default: false,
    },
    isMe: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      availableSlot: [],
      manualTimeToDelete: null,
      isProcessing: false,
      requestedTime: [],
    }
  },
  mounted() {
    this.availableSlot = workPatternHelper(this.rows, this.selectedDateRange, this.timezone)
    if (this.isMe) {
      this.getRequestedTime()
    }
  },
  methods: {
    getBgColor(item) {
      if (item.manual) return 'bg-warning'
      return item.working ? 'bg-success-light' : ''
    },
    destroyManualTime() {
      this.isProcessing = true
      useApollo.activities.destroyManualTime({
        projectUid: localStorage.selected_project,
        activityUid: this.manualTimeToDelete.uuid,
      }).then(response => {
        this.manualTimeToDelete = null
        this.$emit('refetch')
        this.showSuccess(response.data?.deleteManualTime?.message)
      }).catch(error => {
        this.showErrorMessage(error)
      }).finally(() => {
        this.isProcessing = false
      })
    },
    getRequestedTime() {
      useApollo.activities.getMyPendingManualTime({
        projectId: localStorage.selected_project,
      }).then(response => {
        this.requestedTime = response.data.me.pendingManualTimes.data
      })
    },
  },
}
</script>
<style scoped>
 .bg-success-light {
   background-color: #2ee98173 !important;
 }
 .bg-warning td {
  color: #555 !important;
 }
</style>

<style lang="scss">
.manual-time {
  width: 100%;
  table-layout: fixed;
  .text-truncate--3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    padding: 4px 28px;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }
}
</style>
